"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectConfigSchema = exports.ProjectConfigBribeSchema = exports.ProjectConfigGaugeSchema = exports.ProjectConfigSyntheticShema = exports.DexRouterAddressSchema = exports.AllocationVaultAddressSchema = exports.MerkleVaultAddressSchema = exports.ContractAddressSchema = exports.ExternalSourceSchema = exports.ExternalSourcePurposeEnum = exports.YieldConfigSchema = exports.SyntheticTypeEnum = exports.DexRouterTypeEnum = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
const Yield_1 = require("./Yield");
var DexRouterTypeEnum;
(function (DexRouterTypeEnum) {
    DexRouterTypeEnum["FIXED"] = "FIXED";
    DexRouterTypeEnum["VARIABLE"] = "VARIABLE";
    DexRouterTypeEnum["UNIVERSAL"] = "UNIVERSAL";
})(DexRouterTypeEnum || (exports.DexRouterTypeEnum = DexRouterTypeEnum = {}));
var SyntheticTypeEnum;
(function (SyntheticTypeEnum) {
    SyntheticTypeEnum["CONSTANT"] = "CONSTANT";
    SyntheticTypeEnum["DECREASING"] = "DECREASING";
})(SyntheticTypeEnum || (exports.SyntheticTypeEnum = SyntheticTypeEnum = {}));
exports.YieldConfigSchema = zod_1.z.object({
    id: zod_1.z.string({ required_error: 'yield id is required' }),
    type: zod_1.z.nativeEnum(Yield_1.YieldTypeEnum),
    contractAddress: zod_1.z.string({ required_error: 'yield contractAddress is required' }),
    vaultAddress: zod_1.z.string().optional().nullable(),
    tokenID: zod_1.z.string({ required_error: 'yield tokenID is required' }),
    shareTokenID: zod_1.z.string().optional().nullable(),
});
var ExternalSourcePurposeEnum;
(function (ExternalSourcePurposeEnum) {
    ExternalSourcePurposeEnum["CLAIMED_REWARDS"] = "CLAIMED_REWARDS";
    ExternalSourcePurposeEnum["TOKEN_CHECKPOINTS"] = "TOKEN_CHECKPOINTS";
    ExternalSourcePurposeEnum["SYNTHETICS"] = "SYNTHETICS";
    ExternalSourcePurposeEnum["EPOCH_REWARDS"] = "EPOCH_REWARDS";
    ExternalSourcePurposeEnum["DYNAMIC_PROJECT_CONFIG_LOADING"] = "DYNAMIC_PROJECT_CONFIG_LOADING";
    ExternalSourcePurposeEnum["POOL_CHECKPOINTS"] = "POOL_CHECKPOINTS";
})(ExternalSourcePurposeEnum || (exports.ExternalSourcePurposeEnum = ExternalSourcePurposeEnum = {}));
exports.ExternalSourceSchema = zod_1.z.object({
    purposes: zod_1.z.array(zod_1.z.nativeEnum(ExternalSourcePurposeEnum)),
    uri: zod_1.z.string({ required_error: 'external source uri is required' }),
});
exports.ContractAddressSchema = zod_1.z.object({
    id: zod_1.z.string(),
    address: zod_1.z.string(),
});
exports.MerkleVaultAddressSchema = exports.ContractAddressSchema;
exports.AllocationVaultAddressSchema = exports.ContractAddressSchema;
exports.DexRouterAddressSchema = zod_1.z.object({
    id: zod_1.z.string(),
    address: zod_1.z.string(),
    type: zod_1.z.nativeEnum(DexRouterTypeEnum).optional().nullable(),
});
exports.ProjectConfigSyntheticShema = zod_1.z.object({
    id: zod_1.z.string(),
    escrowedTokenId: zod_1.z.string(),
    type: zod_1.z.nativeEnum(SyntheticTypeEnum),
    vaultAddress: zod_1.z.string().optional().nullable(),
    voterAddress: zod_1.z.string().optional().nullable(),
    rebaseAddress: zod_1.z.string().optional().nullable(),
    epochDuration: zod_1.z.number().int().positive().optional().nullable(),
    maxLockDuration: zod_1.z.number().int().positive().optional().nullable(),
    minLockDuration: zod_1.z.number().int().positive().optional().nullable(),
    minterAddress: zod_1.z.string().optional().nullable(),
});
exports.ProjectConfigGaugeSchema = zod_1.z.object({
    poolID: zod_1.z.string(),
    address: zod_1.z.string(),
    rewardTokenID: zod_1.z.string(),
});
exports.ProjectConfigBribeSchema = zod_1.z.object({
    poolID: zod_1.z.string(),
    address: zod_1.z.string(),
});
exports.ProjectConfigSchema = zod_1.z.object({
    id: zod_1.z.string({ required_error: 'id is required' }),
    key: zod_1.z.string({ required_error: 'key is required' }),
    chainID: zod_1.z.number({ required_error: 'chainID is required' }),
    tokens: zod_1.z.array(core_contracts_ifaces_1.TokenSchema),
    pools: zod_1.z.array(core_contracts_ifaces_1.PoolSchema),
    addresses: zod_1.z.array(zod_1.z.object({
        tokenID: zod_1.z.string({ required_error: 'tokenID is required' }),
        address: zod_1.z.string({ required_error: 'address is required' }),
        feed: zod_1.z.string().optional().nullable(),
        feedAux: zod_1.z.string().optional().nullable(),
    })),
    yields: zod_1.z.array(exports.YieldConfigSchema).optional().nullable(),
    externalSources: zod_1.z.array(exports.ExternalSourceSchema),
    balances: zod_1.z.array(zod_1.z.string()),
    contractAddresses: zod_1.z.array(exports.ContractAddressSchema).optional().nullable(),
    contractBalances: zod_1.z.array(zod_1.z.string()).optional().nullable(),
    merkleVaults: zod_1.z.array(exports.MerkleVaultAddressSchema).optional().nullable(),
    allocationVaults: zod_1.z.array(exports.AllocationVaultAddressSchema).optional().nullable(),
    dexRouters: zod_1.z.array(exports.DexRouterAddressSchema).optional().nullable(),
    synthetics: zod_1.z.array(exports.ProjectConfigSyntheticShema).optional().nullable(),
    gauges: zod_1.z.array(exports.ProjectConfigGaugeSchema).optional().nullable(),
    bribes: zod_1.z.array(exports.ProjectConfigBribeSchema).optional().nullable(),
    offsetEpochID: zod_1.z.number().optional().nullable(),
});
